import React, {useEffect} from "react";
import {Redirect} from "react-router-dom";
import {Stack, Text, View} from "@unibuddy/patron";
import {useAnalytics} from "@unibuddy/tracking";
import {useErrorReporting} from "@unibuddy/error-reporting";
import {useAsyncLocalStorage} from "ubcommunity-shared/src/Auth/AuthProvider/useAsyncLocalStorage";
import useAuth from "ubcommunity-shared/src/Auth/hooks/useAuth";
import {LocalStorageNames} from "ubcommunity-shared/src/constants";
import {SSOError} from "ubcommunity-shared/src/Auth/SSO/SSOError";
import {useMeQueryQuery} from "ubcommunity-shared/src/types";
import ActivityIndicator from "ubcommunity-shared/src/General/ActivityIndicator/ActivityIndicator";
import {boldFontStyles} from "ubcommunity-shared/src/Styles/fontStyles";

export const SSOSuccess = () => {
    const {data, error: meError} = useMeQueryQuery();
    const {authState, setAuth} = useAuth();
    const {aliasVisitor} = useAnalytics();
    const {value} = useAsyncLocalStorage(LocalStorageNames.SSO_FLOW, undefined);
    const {value: inviteId} = useAsyncLocalStorage(LocalStorageNames.INVITE_ID, undefined);
    const {reportError} = useErrorReporting();
    const me = data?.me;
    const verified = me?.anyUser?.verified;

    useEffect(() => {
        const callback = async () => {
            if (me?.anyUser?.id) {
                await aliasVisitor({id: me.anyUser.id});
                setAuth({...(authState ?? {}), me});
            }
        };
        callback();
    }, [me, authState, setAuth, aliasVisitor]);

    useEffect(() => {
        if (meError) {
            reportError(meError);
        }
    }, [meError, reportError]);

    if (verified && inviteId) {
        return <Redirect to={`/invite/${inviteId}`} />;
    }

    if (verified) {
        return <Redirect to={`/u/${value?.slug}`} />;
    }

    if (meError) return <SSOError slug={value?.slug} />;

    return (
        <View alignItems="center" margin="large" justifyContent="center" paddingX="large">
            <Stack space="large">
                <ActivityIndicator />
                <Text
                    // @ts-ignore
                    style={{
                        ...boldFontStyles,
                    }}
                >
                    Redirecting you to the app
                </Text>
            </Stack>
        </View>
    );
};
